import { createFileRoute } from '@tanstack/react-router';

import { ProjectsErrorScreen } from '../../features/projects/error-screen';
import { validateProjectListSearch } from '../../features/projects/list-filters';
import { ProjectList } from '../../features/projects/project-list';
import { ProjectsToastProvider } from '../../features/projects/toast';

/**
 * `/projects` (§6.2). المسار رقيق بحكم البنية: الفلاتر تعيش في search params
 * (§1.2 — الروابط قابلة للمشاركة والرجوع بالتاريخ يحفظ السياق)، وكل ما عدا ذلك في
 * `features/projects`.
 */
export const Route = createFileRoute('/projects/')({
  validateSearch: validateProjectListSearch,
  component: ProjectsScreen,
  errorComponent: ProjectsErrorScreen,
});

function ProjectsScreen() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ProjectsToastProvider>
      <ProjectList
        title="المشاريع"
        search={search}
        onSearchChange={(next) => void navigate({ search: () => next })}
      />
    </ProjectsToastProvider>
  );
}
